import script from "./MonthlyReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyReportTable.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyReportTable.vue?vue&type=style&index=0&id=6a5f2ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5f2ea8"]])

export default __exports__